import { fetchWorkspaceUser } from './effects';
import { $workspaceUser } from './states';

// Fetch core user
$workspaceUser.on(fetchWorkspaceUser.doneData, (_, data) => data);
